import { useState, useEffect } from "react";
import useHelpers from "Hooks/useHelpers";

/** Creates a timer that increments every second and displays hours, minutes, seconds. */
export default function IntegrationRunTime({
    start_time = 0,
}: {
    readonly start_time: number;
}) {
    const [time, setTime] = useState(start_time);

    const { formatSeconds } = useHelpers();

    useEffect(() => {
        const interval = setInterval(() => {
            setTime((prev) => prev + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return <span>{formatSeconds(time)}</span>;
}
